import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';

import adminSVG from './img/admin.svg';
import cashierSVG from './img/cashier.svg';
import userAddSVG from './img/user-add.svg';
import usersSVG from './img/users.svg';

import './DashboardUsers.scss';

const b = block('dashboard-users-mobile');

const DashboardUsers = () => {
  const locale = useSelector(state => state.locale.locale.dashboardLocale);
  const { users } = useSelector(state => state.statistic, shallowEqual);
  const { role } = useSelector(state => state.auth);

  return (
    <section className={b()}>
      <div className={b('header')}>
        <div className={b('header-text')}>{locale.users}</div>
        <div className={b('button')}>
          <Button color="pale" link="/users-list">
            <SVG className={b('button-icon')} svgProps={{ svg: usersSVG }} />
            <span className={b('button-text')}>{locale.allUsers}</span>
          </Button>
        </div>
      </div>

      <div className={b('data')}>
        <div className={b('item')}>
          <div className={b('item-data')}>
            <SVG className={b('item-icon')} svgProps={{ svg: usersSVG }} />
            <div className={b('item-label')}>{locale.totalPlayers}</div>
          </div>
          <div className={b('item-value')}>{users.totalPlayers}</div>
        </div>

        {role > 1 && <div className={b('item')}>
          <div className={b('item-data')}>
            <SVG className={b('item-icon')} svgProps={{ svg: cashierSVG }} />
            <div className={b('item-label')}>{locale.totalCashiers}</div>
          </div>
          <div className={b('item-value')}>{users.totalCashiers}</div>
        </div>}

        {role > 2 && <div className={b('item')}>
          <div className={b('item-data')}>
            <SVG className={b('item-icon')} svgProps={{ svg: adminSVG }} />
            <div className={b('item-label')}>{locale.totalAdmins}</div>
          </div>
          <div className={b('item-value')}>{users.totalAdmins}</div>
        </div>}

        <div className={b('item', { separated: role > 1 })}>
          <div className={b('item-data')}>
            <SVG className={b('item-icon')} svgProps={{ svg: userAddSVG }} />
            <div className={b('item-label')}>{locale.registeredToday}</div>
          </div>
          <div className={b('item-value')}>
            {users.playersRegisteredToday
              ? `+${users.playersRegisteredToday}`
              : users.playersRegisteredToday}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardUsers;
